<template>
    <div class="footer">
        
        <div class="content">
            <img class="foot-logo" src="../assets/img/home/bottom-logo.png" alt="">
            <div class="sub-content">
                <div class="left">
                    <div class="title">友情链接</div>
                    <div class="link-item">
                        <a href="https://msa.zibo.gov.cn/" target="_blank" class="item">淄博市市场监督管理局</a>
                        <a href="https://nqi.amr.shandong.gov.cn/#/" target="_blank" class="item" rel="noopener noreferrer">山东省质量基础设施一站式服务平台</a>
                        <!-- <a href="https://www.greatnqi.com/" target="_blank" class="item" rel="noopener noreferrer">高质通一站式云服务平台</a>
                        <a href="https://www.bzwy.cn/" target="_blank" class="item" rel="noopener noreferrer">标准无忧</a>
                        <a href="https://www.feijianwuyou.com/" target="_blank" class="item">飞检无忧</a> -->
                    </div>
                    <div class="banquan-list">
                        <div class="item">版权所有: <span style="margin-left: 10px;">淄博市市场监督管理局</span></div>
                        <div class="item">ICP备案号: <a href="https://beian.miit.gov.cn/" target="_blank" class="item" style="margin-left: 10px;">鲁ICP备2021039409号</a></div>
                    </div>
                </div>
                <div class="right">
                    <div class="title">联系我们</div>
                    <div class="info">
                        <div class="desc" style="margin-bottom: 10px;">客服电话: <span style="margin-left: 10px;">18915263380</span></div>
                        <div class="desc">地<span style="margin-left: 2em;">址</span>: <span style="margin-left: 10px;">淄博市张店区华光路96号</span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { Calendar } from "@element-ui";
export default {
    name: "Header",
    data() {
        return {
            playArr: "name2",
        };
    },
};
</script>

<style lang="less">

.footer {
    width: 100%;
    height: 350px;
    background-color: #3A3A3A;
    .content {
        width: 1100px;
        height: 100%;
        margin: 0 auto;
        padding: 30px 0;
        box-sizing: border-box;
        .foot-logo {
            width: 60%;
        }
        .sub-content {
            margin-top: 30px;

            display: flex;
            justify-content: space-between;
            .left {
                width: 70%;
                .title {
                    font-size: 18px;
                    font-weight: bold;
                    color: #fff;
                }
                .link-item {
                    color: #999;
                    font-size: 14px;

                    display: flex;
                    flex-wrap: wrap;
                    justify-content: flex-start;//space-between;
                    .item {
                        width: 250px;
                        line-height: 50px;
                    }
                }
                .banquan-list {
                    margin-top: 20px;
                    color: #999;
                    font-size: 14px;

                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    .item {
                        width: 50%;
                        margin-bottom: 10px;
                    }
                }
            }
            .right {
                width: 30%;
                .title {
                    font-size: 18px;
                    font-weight: bold;
                    color: #fff;
                }
                .info {
                    margin-top: 40px;
                    color: #999;
                    font-size: 14px;

                }
            }
        }
    }
}
</style>
